export const constants = {
  serverUrl: "http://13.127.62.107:8082",
};
